<h1>{{ dialogParams.title }}</h1>
<div class="di-text">{{ dialogParams.message }}</div>
<div class="pt-24 di-footer">
    <button id="button-show-confirm-ok" nz-button nzType="primary" (click)="modal.destroy()">
        {{ dialogParams.confirmText }}
    </button>
</div>
